import React from 'react';

const UseCases = () => {
  return (
    <div style={{
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
      color: '#333'
    }}>
      {/* Hero Section */}
      <div style={{
        textAlign: 'center',
        marginBottom: '40px',
        padding: '60px 20px',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        borderRadius: '20px'
      }}>
        <h1 style={{
          fontSize: '48px',
          fontWeight: 'bold',
          marginBottom: '25px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
        }}>
          💼 Real-World Use Cases for Name Pickers
        </h1>
        <p style={{
          fontSize: '22px',
          marginBottom: '35px',
          opacity: '0.95',
          maxWidth: '900px',
          margin: '0 auto 35px'
        }}>
          Discover hundreds of creative ways to use our <strong>random name generator</strong> across education, business, entertainment, and personal applications.
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: 'white',
            color: '#764ba2',
            padding: '18px 40px',
            borderRadius: '35px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '20px',
            boxShadow: '0 6px 20px rgba(0,0,0,0.3)'
          }}
        >
          Explore Use Cases Now 🚀
        </a>
      </div>

      {/* Education Section */}
      <div style={{
        backgroundColor: 'white',
        padding: '50px',
        borderRadius: '15px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🎓 Educational Applications
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            padding: '30px',
            borderRadius: '12px',
            backgroundColor: '#fff3e0',
            border: '2px solid #ffcc80'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#e65100',
              marginBottom: '20px'
            }}>
              📚 Elementary School
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                Reading group rotation with our <strong>student name randomizer</strong>
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                Line leader selection for daily activities
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                Show and tell presenter picker
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                Classroom helper assignment system
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#e65100' }}>•</span>
                PE team captain selection
              </li>
            </ul>
          </div>

          <div style={{
            padding: '30px',
            borderRadius: '12px',
            backgroundColor: '#e8f5e8',
            border: '2px solid #a5d6a7'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#2e7d32',
              marginBottom: '20px'
            }}>
              🔬 Middle & High School
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Science lab partner assignment using <strong>random student selector</strong>
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Debate topic and position assignments
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Presentation order for group projects
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Random questioning during lessons
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#2e7d32' }}>•</span>
                Student council election processes
              </li>
            </ul>
          </div>

          <div style={{
            padding: '30px',
            borderRadius: '12px',
            backgroundColor: '#f3e5f5',
            border: '2px solid #ce93d8'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#7b1fa2',
              marginBottom: '20px'
            }}>
              🎓 Higher Education
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Graduate seminar discussion leaders
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Research presentation scheduling
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Study group coordinator selection
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Thesis defense committee assignments
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#7b1fa2' }}>•</span>
                Cold-calling for participation
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Business Section */}
      <div style={{
        backgroundColor: '#f8f9fa',
        padding: '50px',
        borderRadius: '15px',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🏢 Business & Professional Uses
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
          gap: '30px'
        }}>
          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '20px'
            }}>
              👥 Team Building & HR
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Cross-functional team formation
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Icebreaker activity participant selection
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Employee recognition program draws
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Training session volunteer picker
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Office party game coordinator
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '20px'
            }}>
              📊 Meetings & Presentations
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Meeting facilitator rotation
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Presentation order in board meetings
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Stand-up meeting speaking order
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Client pitch team leader selection
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Conference breakout session moderators
              </li>
            </ul>
          </div>

          <div style={{
            backgroundColor: 'white',
            padding: '30px',
            borderRadius: '12px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
          }}>
            <h3 style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#dc2626',
              marginBottom: '20px'
            }}>
              🎯 Sales & Marketing
            </h3>
            <ul style={{ listStyle: 'none', padding: '0' }}>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Trade show booth visitor prizes
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Customer appreciation event drawings
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Social media contest winner selection
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Product launch campaign giveaways
              </li>
              <li style={{ marginBottom: '10px', paddingLeft: '25px', position: 'relative' }}>
                <span style={{ position: 'absolute', left: '0', color: '#dc2626' }}>•</span>
                Email subscriber milestone rewards
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Creative Applications */}
      <div style={{
        backgroundColor: 'white',
        padding: '50px',
        borderRadius: '15px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.1)',
        marginBottom: '40px'
      }}>
        <h2 style={{
          fontSize: '38px',
          fontWeight: 'bold',
          textAlign: 'center',
          color: '#333',
          marginBottom: '40px'
        }}>
          🎨 Creative & Unique Applications
        </h2>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '25px'
        }}>
          <div style={{
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#fff3e0',
            border: '2px solid #ffcc80',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>📖</div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#e65100',
              marginBottom: '12px'
            }}>
              Story Writing
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Use character names for collaborative storytelling, plot development, or creative writing exercises in workshops.
            </p>
          </div>

          <div style={{
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#e8f5e8',
            border: '2px solid #a5d6a7',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>🍳</div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#2e7d32',
              marginBottom: '12px'
            }}>
              Recipe Selection
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Random meal planning by adding recipe names to discover new dishes and break cooking routines.
            </p>
          </div>

          <div style={{
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#f3e5f5',
            border: '2px solid #ce93d8',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>🌍</div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#7b1fa2',
              marginBottom: '12px'
            }}>
              Travel Planning
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Add destination options for spontaneous travel decisions or bucket list prioritization.
            </p>
          </div>

          <div style={{
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#e3f2fd',
            border: '2px solid #90caf9',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>🎭</div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#1565c0',
              marginBottom: '12px'
            }}>
              Theatre & Drama
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Cast role assignments, improv scene partner selection, and drama class exercise coordination.
            </p>
          </div>

          <div style={{
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#fff8e1',
            border: '2px solid #ffe082',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>🏥</div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#f57c00',
              marginBottom: '12px'
            }}>
              Healthcare Training
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Medical scenario role-play assignments and patient case study presentations in training programs.
            </p>
          </div>

          <div style={{
            padding: '25px',
            borderRadius: '12px',
            backgroundColor: '#fce4ec',
            border: '2px solid #f8bbd9',
            textAlign: 'center'
          }}>
            <div style={{
              fontSize: '48px',
              marginBottom: '15px'
            }}>🎪</div>
            <h3 style={{
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#c2185b',
              marginBottom: '12px'
            }}>
              Community Events
            </h3>
            <p style={{ fontSize: '16px', color: '#666' }}>
              Volunteer coordinator selection, community service project assignments, and charity event organization.
            </p>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div style={{
        textAlign: 'center',
        padding: '60px 30px',
        background: 'linear-gradient(135deg, #ff9a9e 0%, #fecfef 50%, #fecfef 100%)',
        borderRadius: '20px'
      }}>
        <h2 style={{
          fontSize: '42px',
          fontWeight: 'bold',
          marginBottom: '25px',
          color: '#333'
        }}>
          Inspired by These Use Cases? 💫
        </h2>
        <p style={{
          fontSize: '22px',
          marginBottom: '35px',
          color: '#444',
          maxWidth: '700px',
          margin: '0 auto 35px'
        }}>
          Whether you need a <strong>classroom tool</strong>, <strong>business solution</strong>, or <strong>entertainment feature</strong> - our name picker adapts to any scenario!
        </p>
        <a 
          href="/"
          style={{
            display: 'inline-block',
            backgroundColor: '#667eea',
            color: 'white',
            padding: '20px 45px',
            borderRadius: '35px',
            textDecoration: 'none',
            fontWeight: 'bold',
            fontSize: '22px',
            boxShadow: '0 8px 25px rgba(102, 126, 234, 0.4)'
          }}
        >
          Try Your Use Case Now →
        </a>
        <div style={{
          marginTop: '25px',
          fontSize: '18px',
          color: '#555'
        }}>
          Free forever • Unlimited uses • Works everywhere
        </div>
      </div>
    </div>
  );
};

export default UseCases;